module.exports = __webpack_public_path__ + "static/media/FF949329-CA30-4BAD-A8B4-42E3D8837E59.2162baeb.jpeg";